import React, { Component } from 'react';
import { FlatList, Text, View, UploadList, StatusBox, TimeStamp, ASButton, WebBrowser, FilePicker, Button } from 'core';
import * as actions from 'actions';
import { css, theme } from 'constants';
import { whyCompUpdated } from 'utils';
import { IcoTrash, IcoDownload, IcoDoc, IcoFileType } from 'utils/icons';
import { getUploadedFiles } from 'selectors';
import { lang } from 'lang';

const styles = css({
  item: {
    marginVertical: 1,
    marginHorizontal: 10,
    backgroundColor: theme.gray_color_lighten(0.07),
    padding: 5,
    borderRadius: 10,
    flexDirection: 'row',
    alignItems: 'center'
  },
  text: {
    flex: 1
  },
  header: {
    padding: 30,
    alignItems: 'center',
    minHeight: 110
  }
});

const EmptyList = ({ is_admin }) => (
  <View style={{ margin: 20, marginTop: 100, alignItems: 'center' }}>
    {is_admin ? (
      <Text style={{ fontSize: theme.font_xl, marginBottom: 20, color: theme.gray_color_lighten(0.4) }}>{lang.NO_MATERIAL_ADMIN}</Text>
    ) : (
      <Text style={{ fontSize: theme.font_xl, color: theme.gray_color_lighten(0.4) }}>{lang.NO_MATERIAL_MEMBER}</Text>
    )}
  </View>
);

class Material extends Component {
  componentDidUpdate(pProps) {
    whyCompUpdated(pProps, this.props);
  }

  _onFilesAdded = files => {
    const { group_id } = this.props;
    actions.sendFiles({
      g_id: 'material',
      u_id: group_id,
      files,
      onSuccess: () => actions.sendMaterial({ upload: getUploadedFiles({ g_id: 'material', u_id: group_id }), group_id })
    });
  };

  render() {
    const { is_admin, group_id, upload_list, add_status, remove_status, materials } = this.props;
    const keyExtractor = item => item.id;
    const flatListHeader = is_admin ? (
      <View style={styles.header}>
        <Button
          title={lang.UPLOAD}
          onPress={() => FilePicker.show({ asset_type: FilePicker.TYPES.ALL, multiple: true }, this._onFilesAdded)}
          status={add_status}
          onSuccess={() => {
            actions.markUploadFinished({ g_id: 'material', u_id: group_id });
            actions.fetch.markFinished(add_status.type);
          }}
        />
        <StatusBox
          status={remove_status}
          onSuccess={() => {
            actions.fetch.markFinished(remove_status.type);
          }}
        />
        <UploadList files={upload_list} />
      </View>
    ) : (
      <View style={{ height: 10 }} />
    );

    return (
      <FlatList
        data={materials}
        keyExtractor={keyExtractor}
        ListHeaderComponent={flatListHeader}
        ListEmptyComponent={() => <EmptyList is_admin={is_admin} />}
        renderItem={({ item }) => {
          let options = [
            { icon: IcoDoc, text: lang.VIEW, onPress: () => WebBrowser.show(item) },
            { icon: IcoDownload, text: lang.DOWNLOAD, onPress: () => WebBrowser.download(item) }
          ];
          options = is_admin ? [...options, { icon: IcoTrash, text: lang.DELETE, onPress: () => actions.removeMaterial({ upload_id: item.id, group_id }) }] : options;

          return (
            <View style={styles.item}>
              <IcoFileType name={item.name} size={50} />
              <View style={styles.text}>
                <Text ellipsizeMode={'tail'} numberOfLines={1}>
                  {item.name.replace(item.ext, '')}
                </Text>
                <TimeStamp value={item.created} only_relative style={{ marginTop: 3 }} />
              </View>
              <ASButton options={options} />
            </View>
          );
        }}
      />
    );
  }
}

export default Material;



// WEBPACK FOOTER //
// ./src/components/right/group_material.js